
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/easy-quote",
      function () {
        return require("private-next-pages/easy-quote/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/easy-quote"])
      });
    }
  